import { User, AppState, LoginState, isLoggedInState } from "../components/portal/state";
import * as React from "react"
import * as i18next from 'i18next'
import { Action, loadingAsyncState } from "widgets-for-react";
import { State, ExtraUserInfo } from "./portal_client";
import { Characteristic } from "./characteristic";
import * as CustomComponents from '../components/custom_components'
import * as Immutable from "immutable"
import { Characteristic as CharacteristicType } from './portal/types'

export type ProductCharacteristicsProps = { user:()=>User<ExtraUserInfo>, setState: (_: Action<LoginState<State, ExtraUserInfo>>) => void, state: LoginState<State, ExtraUserInfo> }
export class ProductCharacteristics extends React.Component<ProductCharacteristicsProps>  {
  constructor(props:ProductCharacteristicsProps, context:any) {
    super(props, context)
  }

  render() {
      if (isLoggedInState(this.props.state)) {
        let state = this.props.state
        let prod_configs = this.props.state.appState.productConfigurations
        let { selectedProductConfiguration } = this.props.state.appState
        let prodConf = prod_configs.get(this.props.state.appState.selectedProductConfiguration)
        let async_characteristics = prodConf.CharacteristicArray
        let characteristics = async_characteristics.kind == "loaded" ? async_characteristics.value : this.props.state.appState.cachedCharacteristics 
        if (characteristics) {
          let characteristics_size = characteristics.length
          return characteristics.map((ch, i) => 
            <li
              className={`expand__item ${(ch.Id === prod_configs.get(selectedProductConfiguration).SelectedCharacteristic) ? "expand__item--open" : ""}`}
              aria-current={(ch.Id === prod_configs.get(selectedProductConfiguration).SelectedCharacteristic) ? "step" : false }
              key={ch.Id}
            >
              <Characteristic 
                key={ch.Id}
                showSummary={characteristics.findIndex(c => ch.Id == c.Id && c.ValueOptions.length == 1) > -1 || prodConf.CharacteristicValues.findIndex(cv => cv.CharacteristicId == ch.Id) > -1}
                user={this.props.user}
                setState={this.props.setState}
                state={this.props.state}
                label={ch.Text}
                characteristicId={ch.Id}
                helpText={ch.Range != null ? `${i18next.t('quotation_request:product.range_explanation')} ${ch.Range}`: null} // TODO this should be real helptext when we get this from SAP. Maybe append range to end of helptext if present
                characteristicValues={Immutable.List(ch.ValueOptions.map(option => ({value: option.ValueId, label: option.Value})))}
                range={ch.Range}
                component=
                { this.SelectorType(ch) == "dropdown" ? CustomComponents.Dropdown( 
                  true,
                  'edit',
                  ch.Text,
                  'Search...',
                  'mui-select',
                  Immutable.List(ch.ValueOptions.map(option => ({value: option.ValueId, label: option.Value}))),
                  () => this.props.state.appState.productConfigurations.get(this.props.state.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id) ? ch.ValueOptions.map(option => ({value: option.ValueId, label: option.Value})).find(value => value.value == this.props.state.appState.productConfigurations.get(this.props.state.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id).CharacteristicValueId) : null,
                  v => this.props.setState(s =>
                    {if (isLoggedInState(s)) {
                      let prod_configs = s.appState.productConfigurations
                      if (prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id)) {
                        prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id).CharacteristicValueId = v.value
                      } else {
                        prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.push({CharacteristicId: ch.Id, CharacteristicValueId: v.value}) 
                      }

                      return ({...s, appState: {...s.appState, productConfigurations: prod_configs }})}})

                ): this.SelectorType(ch) == "text" ? 
                  <input
                    type="text"
                    className="form__input"
                    value={!!this.props.state.appState.productConfigurations.get(this.props.state.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id) ? this.props.state.appState.productConfigurations.get(this.props.state.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id).CharacteristicValueId || "" : ""}
                    onChange={(e) => {
                      e.preventDefault()
                      let v = e.currentTarget.value
                      this.props.setState(s => 
                      {if (isLoggedInState(s)) {
                        let prod_configs = s.appState.productConfigurations
                        if (prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id)) {
                          prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id).CharacteristicValueId = v
                        } else {
                          prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.push({CharacteristicId: ch.Id, CharacteristicValueId: v}) 
                        }
  
                        return ({...s, appState: {...s.appState, productConfigurations: prod_configs }})}
                      }
                      )
                    }}
                  />
                : CustomComponents.CheckboxOrRadio(this.SelectorType(ch),
                  true,
                  'edit',
                  ch.Text,
                  Immutable.List(ch.ValueOptions.map(option => ({value: option.ValueId, label: option.Value}))),
                  () => this.props.state.appState.productConfigurations.get(this.props.state.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id) ? this.props.state.appState.productConfigurations.get(this.props.state.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id).CharacteristicValueId : null,
                  v => this.props.setState(s =>
                    {if (isLoggedInState(s)) {
                      let prod_configs = s.appState.productConfigurations
                      if (prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id)) {
                        prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.find(value => value.CharacteristicId == ch.Id).CharacteristicValueId = v
                      } else {
                        prod_configs.get(s.appState.selectedProductConfiguration).CharacteristicValues.push({CharacteristicId: ch.Id, CharacteristicValueId: v}) 
                      }

                      return ({...s, appState: {...s.appState, productConfigurations: prod_configs }})}})
                )}
              />
            </li>
          )
        } else {
          return <></>
        }
      } else {
        return <></>
      }
  }

  SelectorType(characteristic: CharacteristicType) {
    const length = characteristic.ValueOptions.length
    if (length < 1) {
      return "text"
    } else if (length > 9 && characteristic.SelectorType != "C" && characteristic.SelectorType != "M")
      return "dropdown"
    else if (characteristic.SelectorType == "C" || characteristic.SelectorType == "M")
      return "checkbox"
    else
      return "radio"
  }
}

export const ProductCharacteristicsElement =
  (
    user: ()=> User<ExtraUserInfo>,
    setState: (_: Action<LoginState<State, ExtraUserInfo>>) => void,
    state: LoginState<State, ExtraUserInfo>,
    label: string,
    component: JSX.Element,
    characteristicId: string,
    nextCharacteristicId: string
  ):JSX.Element => <ProductCharacteristics user={user} setState={setState} state={state} />
